import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-728761a1"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "row-span-1 text-sm sm:text-base lg:text-sm xl:text-base" }
const _hoisted_2 = { class: "font-bold text-xl sm:text-4xl lg:text-xl xl:text-4xl" }
const _hoisted_3 = {
  class: "h-fit bg-yellow-100 border-l-4 border-yellow-500 text-yellow-700 p-4 my-4",
  role: "alert"
}
const _hoisted_4 = { class: "mb-3" }
const _hoisted_5 = { class: "row-span-2 my-10 p-6 max-w-sm h-fit bg-white rounded-lg border border-gray-200 shadow-md dark:bg-gray-800 dark:border-gray-700 text-sm sm:text-base lg:text-sm xl:text-base" }
const _hoisted_6 = { class: "mb-3" }
const _hoisted_7 = { class: "font-bold" }
const _hoisted_8 = { class: "mb-3" }
const _hoisted_9 = { class: "font-bold" }
const _hoisted_10 = {
  key: 0,
  class: "h-fit bg-yellow-100 border-l-4 border-yellow-500 text-yellow-700 p-4 my-4",
  role: "alert"
}
const _hoisted_11 = { class: "font-bold" }
const _hoisted_12 = { class: "row-span-1 text-sm sm:text-base lg:text-sm xl:text-base" }
const _hoisted_13 = { class: "pb-10" }

import DiagnosticSection from '@/components/video-diagnostic/DiagnosticSection.vue'
import { Stage } from '@/types/enums/video-diagnostic.enum'
import UAParser from 'ua-parser-js'
import { onMounted, ref } from 'vue'
import { useI18n } from 'vue-i18n'


export default /*#__PURE__*/_defineComponent({
  __name: 'SupportedBrowser',
  props: {
  stage: {
    type: Number,
    required: true,
  },
},
  emits: ["nextStage"],
  setup(__props, { emit: __emit }) {


const i18n = useI18n()
const emit = __emit

const isWarned = ref<boolean>(false)
const warnText = ref<string>('')

const userAgentParser = new UAParser()
const userAgentInfo = userAgentParser.getResult()
const browser = userAgentInfo.browser
const operatingSystem = userAgentInfo.os

onMounted(async () => {
  /**
   * ref: https://docs.microsoft.com/en-us/microsoft-edge/web-platform/how-to-detect-win11
   * check os window 11
   */
  const userAgentData = await navigator.userAgentData?.getHighEntropyValues(['platformVersion'])
  if (navigator.userAgentData?.platform === 'Windows') {
    const majorPlatformVersion = parseInt(userAgentData?.platformVersion?.split('.')[0] || '')

    if (majorPlatformVersion >= 13) {
      operatingSystem.version = '11'
    }
  }

  /**
   * show warning when Browsers that's not supported User-Agent Client Hints
   */
  if (!userAgentData && operatingSystem.name?.includes('Windows')) {
    warnText.value = i18n.t('video-diagnostic.window-warn')
    isWarned.value = true
  }

  /**
   * show warning when browser might be Firefox on iPad
   * *** also warning when using Safari on Max OS ***
   */
  if (browser.name?.includes('Safari') && operatingSystem.name?.includes('Mac OS')) {
    warnText.value = i18n.t('video-diagnostic.ipad-warn')
    isWarned.value = true
  }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(DiagnosticSection, {
    id: _unref(Stage).BROWSER_TEST,
    class: _normalizeClass(
      __props.stage === _unref(Stage).BROWSER_TEST || __props.stage === _unref(Stage).RESULTS
        ? 'block'
        : 'hidden md:block opacity-30 pointer-events-none'
    )
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("h1", _hoisted_2, _toDisplayString(_ctx.$t('video-diagnostic.browser-supported')), 1),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.$t('video-diagnostic.chrome-suggestion')), 1),
          _createElementVNode("p", null, _toDisplayString(_ctx.$t('video-diagnostic.safari-suggestion')), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("p", _hoisted_6, [
          _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.$t('browser-card.browser')), 1),
          _createTextVNode(" " + _toDisplayString(_unref(browser).name) + " " + _toDisplayString(_unref(browser).version), 1)
        ]),
        _createElementVNode("p", _hoisted_8, [
          _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.$t('browser-card.operating-system')), 1),
          _createTextVNode(" " + _toDisplayString(_unref(operatingSystem).name) + " " + _toDisplayString(_unref(operatingSystem).version), 1)
        ]),
        (isWarned.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
              _createElementVNode("p", _hoisted_11, _toDisplayString(warnText.value), 1)
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("p", _hoisted_13, _toDisplayString(_ctx.$t('video-diagnostic.browser-supported-detail')), 1),
        _createElementVNode("button", {
          class: _normalizeClass([{ 'opacity-30 pointer-events-none': __props.stage === _unref(Stage).RESULTS }, "text-white border-2 rounded-md border-white py-2 px-4"]),
          type: "button",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('nextStage')))
        }, _toDisplayString(_ctx.$t('video-diagnostic.ok')), 3)
      ])
    ]),
    _: 1
  }, 8, ["id", "class"]))
}
}

})